import {appInsights} from '../app-insights';

const EVENT_GUEST_PAYMENT_STATUS = 'PAY_NOW';

export const logGuestPaymentStatusEvent = ({checkoutSessionId, paymentStatus, customerId}: PaymentStatusEvent) => {
  appInsights.trackEvent({
    name: EVENT_GUEST_PAYMENT_STATUS,
    properties: {
      paymentStatus,
      customerId,
      checkoutSessionId,
    },
  });
};
